import { FlexProps } from '@chakra-ui/react';
import { FC } from 'react';
import ErrorBoundary from '../common/ErrorBoundary';
import { FlexCol } from '../common/Flex';

const IdvLayout: FC<FlexProps> = ({ children, ...props }) => {
    return (
        <ErrorBoundary>
            <FlexCol w="full" h="full" justifyContent="center" {...props}>
                {children}
            </FlexCol>
        </ErrorBoundary>
    );
};

export default IdvLayout;
